/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/prop-types */
import { Typography } from '@material-ui/core';
import _ from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import FiltersContext from '../../contexts/FiltersContext';
import StoryContext from '../../contexts/StoryContext';
import { composeWhereClause } from '../../modules/data';
import { rdsTabulate } from '../../modules/rds';
import { stateFIPS } from '../../modules/states';
import { toFormattedNumber } from '../../modules/text';
import BarChart from '../BarChart';
import NoDataVisual from '../NoDataVisual';
import { years } from '../../modules/years';

function ProvidersBySettingType({ height = 300, width }) {
  const { stateCode } = useParams();
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const [noData, setNoData] = useState(false);
  const { primaryColor, secondaryColor } = useContext(StoryContext);
  const { displayBy } = useContext(FiltersContext);

  useEffect(() => {
    setError(null);
    setReady(false);
    setNoData(false);
    const getCapacity = function getCapacity() {
      let whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]} AND qris_participation=1`;
      whereClause += composeWhereClause({}, true, false); // don't use child age

      let measure = 'capacity:SUM(capacity_tot)';
      if (displayBy === 'Providers') {
        measure = 'capacity:SUM(cnt_provider)';
      }

      return rdsTabulate('ccdc', 'tract_licensed_capacity', {
        dims: 'wave_id,qris_code',
        measure,
        where: whereClause,
        format: 'amcharts',
        inject: true,
        orderby: 'qris_code',
      }, false, null); // use cache, unset wave
    };

    getCapacity().then((response) => {
      // console.log(response.parsedBody.dataProvider);
      const dataItems = response.parsedBody.dataProvider;
      if (dataItems.length === 0) {
        setNoData(true);
        return;
      }

      const waveObjects = {};
      dataItems.forEach((di) => {
        let dataObject = { ...di };
        dataObject.qris_code = dataObject.qris_code || 'Not Reported'; // set missing qris_code
        const label = di.wave_id === '2020 Annual Submission' ? 'Pre-Pandemic' : 'Mid-Pandemic';
        const v = {};
        v[label] = di.capacity;
        dataObject = { ...dataObject, ...v };
        const originalDataObject = waveObjects[di.qris_code] || {};
        waveObjects[di.qris_code] = { ...originalDataObject, ...dataObject };
      });
      setData(_.values(waveObjects));
    })
      .catch((e) => {
        setError(e);
      })
      .finally(() => {
        setReady(true);
      });
  }, [stateCode, displayBy]);

  const keys = ['Pre-Pandemic', 'Mid-Pandemic'];
  const groupKey = 'qris_code';

  const title = `Number of ${displayBy} by Quality Rating`;

  const formatterFunction = function formatterFunction(payload) {
    const tooltipLabels = {
      'Pre-Pandemic': years.covidFromMonthYear,
      'Mid-Pandemic': years.covidFromMonthYear,
    };

    if (payload.value) {
      if (payload.payload.qris_code === 'Not Reported') {
        return `${tooltipLabels[payload.dataKey]}: <b>${toFormattedNumber(payload.value)}</b> <b>${displayBy.toLowerCase()}</b> for which quality rating was not reported.`;
      }
      return `${tooltipLabels[payload.dataKey]}: <b>${toFormattedNumber(payload.value)}</b> <b>${payload.payload.qris_code.toLowerCase()}</b> <b>${displayBy.toLowerCase()}</b>.`;
    }
    return 'Insufficient sample size';
  };

  // console.log(data)
  if (noData) {
    return <NoDataVisual message="No state-wide QRIS system" />;
  }

  return (
    <>
      {error && <Typography variant="body1" color="error">{error.message}</Typography>}
      <BarChart
        valueFormatter={toFormattedNumber}
        formatterFunction={formatterFunction}
        height={height}
        width={width}
        ready={ready}
        data={data}
        keys={keys}
        groupKey={groupKey}
        title={title}
        colors={[primaryColor, secondaryColor]}
      />
    </>
  );
}

export default ProvidersBySettingType;
